import { Priority } from "interfaces/priority";
import { useLazyFetchV2 } from "hooks/fetch/useLazyFetchV2";

interface LazyFetchResponse {
  count?: number;
  results?: Priority[];
}

interface LazyFetchPriority {
  loading: boolean;
  error: boolean;
  fetchCallback: (url: string) => Promise<LazyFetchResponse>;
}

export const useLazyGetPriority = (): {
  loading: boolean;
  error: boolean;
  fetchPriority: (queryString?: string) => Promise<LazyFetchResponse>;
} => {
  const { loading, error, fetchCallback }: LazyFetchPriority = useLazyFetchV2(
    "GET"
  );

  return {
    loading,
    error,
    fetchPriority: () => fetchCallback("case_priority_types?ordering=-order")
  };
};
